// @ts-nocheck

export const localeCodes =  [
  "ru-by"
]
export const localeLoaders = {
  "ru-by": [
    {
      key: "locale_ru_46json_8aa2a7c9",
      load: () => import("#nuxt-i18n/8aa2a7c9" /* webpackChunkName: "locale_ru_46json_8aa2a7c9" */),
      cache: true
    },
    {
      key: "locale_ru_45by_46json_6f7893d9",
      load: () => import("#nuxt-i18n/6f7893d9" /* webpackChunkName: "locale_ru_45by_46json_6f7893d9" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/18598af0" /* webpackChunkName: "config_i18n_46config_46ts_18598af0" */)
]
export const normalizedLocales = [
  {
    code: "ru-by",
    iso: "ru-by",
    dir: "ltr",
    country: "by",
    language: "ru"
  }
]

